import { render, staticRenderFns } from "./UrunListFragment.vue?vue&type=template&id=5a7470ae&scoped=true&"
import script from "./UrunListFragment.vue?vue&type=script&lang=js&"
export * from "./UrunListFragment.vue?vue&type=script&lang=js&"
import style0 from "./UrunListFragment.vue?vue&type=style&index=0&id=5a7470ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7470ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VImg,VRow,VTooltip})
